import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { isHostModeSelector } from '../../store/selectors';

export default function useIsServicesPageEnabled() {
    const isHostMode = useSelector(isHostModeSelector);
    return useMemo(() => !process.buildConfigs.disableServicesPage && !isHostMode, [ isHostMode ]);
}
